/* eslint-disable import/no-mutable-exports */
// deploy script replaces magic string below.
// resolve alias for require('kareo-environment-config');
let environmentConfig = '$kareo.environment.config$';

if (!environmentConfig || environmentConfig.indexOf('$') > -1) {
  environmentConfig = 'devint';
}
export default environmentConfig;
